// Page addresses say what the page is called in the menu (/customers,
// /staff, /questions). The old ones (MOVED_ROUTES) still work: they redirect,
// keeping ?search and #hash, so bookmarks and old links land.
export const RouterName = {
  auth: {
    login: "/auth/login",
    signup: "",
    forgotPassword: "/auth/forgot-password",
    resetPassword: "/auth/reset-password/:token",
    maintenance: "/auth/maintenance",
  },
  countriesDetails: {
    countries: "/countries",
    countryProfile: "/countries/:id/profile",
    VisaTypeDetails: "/countries/:id/VisaTypeDetails",
    VisaTypeDetailsNationality: "/countries/:id/VisaTypeDetails/nationality",
    countriesGallery: "/countries/:id/gallery",
    countriesFAQ: "/countries/:id/faq/:group_id",
    countriesWorkingProcess: "/countries/:id/working_process/:group_id",
    countriesPrices: "/countries/:visa_type_id/prices/:id",
    // The same page by the country's own number (the old one above still works).
    countryProducts: "/countries/:id/products/:list_id",
    groups: "/groups",
    groupsFAQ: "/countries/:id/faq/:group_id",
    groupsWorkingProcess: "/countries/:id/working_process/:group_id",
    groupsPrices: "/groups/:visa_type_id/prices/:id",
    questionnaires: "/questions",
    QuestionsCategory: "/question-categories",
    questionnairesByCategory: "/question-categories/:id/questions",
    documents: "/documents",
    nationality: "/nationalities",
    visaType: "/visa-types",
  },
  admins: {
    admins: "/staff",
    privileges: "/roles",
  },
  admins_logs: {
    admins_logs: "/activity-log",
  },
  // A product's checklist and form, by the product's number.
  productDocuments: "/products/:id/documents",
  productQuestions: "/products/:id/questions",
  ListDocuments: "/ListDocuments/:from/:id", // old address: redirects to productDocuments
  // What the rule watch found on the official pages (API docs/rule-watch.md).
  ruleChanges: "/rule-changes",
  ListQuestions: "/ListQuestions/:from/:id", // old address: redirects to productQuestions
  ListQuestionsDocuments: "/ListQuestionsDocuments",
  trustedBy: "/trusted-by",
  testimonials: "/testimonials",
  clients: "/customers",
  working_process: "/how-it-works",
  stats: "/key-numbers",
  services: "/services",
  contact: "/contact",
  waitlist: "/waitlist",
  faq: "/faq",
  // Our mission and the legal pages, apart from Site settings (CMS review round 2, hala-27).
  websiteTexts: "/website-texts",
  settings: {
    settings: "/settings",
  },
  request_reviews: "/request-reviews/:country_id",
  requests: "/requests",
  cases: "/cases",
  // Payments, what is owed and refunds to check (CMS review georges-35).
  money: "/money",
  case: "/cases/:id",
  request: "/request/:id",
  support: "/support",
  home: "/dashboards/ecommerce",
  awards: "/countries/:id/awards",
  userSessions: "/user-ai-chat-sessions/:userId",
};

// Old address -> new one (":name" parts carry over).
export const MOVED_ROUTES = [
  { from: "/questionnaires", to: "/questions" },
  { from: "/questions_category", to: "/question-categories" },
  { from: "/questions_category/:id/questionnaires", to: "/question-categories/:id/questions" },
  { from: "/nationality", to: "/nationalities" },
  { from: "/visa-type", to: "/visa-types" },
  { from: "/admins", to: "/staff" },
  { from: "/privileges", to: "/roles" },
  { from: "/admins-logs", to: "/activity-log" },
  { from: "/clients", to: "/customers" },
  { from: "/working-process", to: "/how-it-works" },
  { from: "/stats", to: "/key-numbers" },
  { from: "/ListDocuments/:from/:id", to: "/products/:id/documents" },
  { from: "/ListQuestions/:from/:id", to: "/products/:id/questions" },
];
